// extracted by mini-css-extract-plugin
module.exports = {"navItem":"NavItem_navItem__3KXAq","navLink":"NavItem_navLink__38F2p","activeNavLink":"NavItem_activeNavLink__2j9uL"};